var _path, _path2, _circle, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9176 34.9348L19.6486 35.2038L21.8797 37.4348H11H8.5V34.9348V32.6592C8.5 31.0023 9.84315 29.6592 11.5 29.6592H25.1932L22.6932 32.1592H11.5C11.2239 32.1592 11 32.383 11 32.6592V34.9348H19.9176Z",
    fill: "#08141E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2639 35.2031L49.4622 6.00478C50.1456 5.32137 51.2537 5.32137 51.9371 6.00478L69.6871 23.7548C70.3705 24.4382 70.3705 25.5463 69.6871 26.2297L59.6896 36.2271C59.3615 36.5553 58.9163 36.7397 58.4522 36.7397L41.2268 36.7397L21.8004 36.7397L20.2639 35.2031Z",
    stroke: "#08141E",
    strokeWidth: 2.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5921,
    cy: 22.248,
    r: 3.97068,
    transform: "rotate(-45 46.5921 22.248)",
    fill: "#08141E",
    stroke: "#08141E",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0367 23.7054C59.726 24.3946 60.0093 25.5674 59.6628 27.0965C59.3196 28.6107 58.3783 30.3226 56.8762 31.8247C55.3741 33.3268 53.6622 34.2681 52.1481 34.6113C50.6189 34.9578 49.4461 34.6745 48.7569 33.9852C48.0677 33.296 47.7843 32.1232 48.1309 30.5941C48.474 29.0799 49.4153 27.3681 50.9174 25.8659C52.4196 24.3638 54.1314 23.4225 55.6456 23.0794C57.1747 22.7328 58.3475 23.0162 59.0367 23.7054Z",
    fill: "#08141E",
    stroke: "#08141E",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 36.4629H61.0399C62.0064 36.4629 62.7899 37.2464 62.7899 38.2129V67.7584C62.7899 68.7249 62.0064 69.5084 61.0399 69.5084H11.5C10.5335 69.5084 9.75 68.7249 9.75 67.7584V36.4629Z",
    stroke: "#08141E",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9461 59.7766C56.5246 61.3415 56.5246 63.8931 54.9461 65.458L47.9495 72.394C46.371 73.9588 46.371 76.5104 47.9495 78.0752C49.5087 79.6209 52.0223 79.6209 53.5815 78.0752L60.6769 71.0412C62.2361 69.4955 64.7498 69.4955 66.3091 71.0412L73.4046 78.0753C74.9638 79.621 77.4774 79.621 79.0366 78.0753C80.615 76.5105 80.615 73.959 79.0366 72.3942L72.0398 65.458C70.4613 63.8931 70.4613 61.3415 72.0398 59.7766L79.0366 52.8404C80.615 51.2756 80.615 48.7241 79.0366 47.1593C77.4774 45.6136 74.9638 45.6136 73.4046 47.1593L66.3091 54.1934C64.7498 55.7391 62.2361 55.7391 60.6769 54.1934L53.5815 47.1594C52.0223 45.6137 49.5087 45.6137 47.9495 47.1594C46.371 48.7242 46.371 51.2758 47.9495 52.8406L54.9461 59.7766Z",
    fill: "url(#paint0_radial_4742_71756)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4742_71756",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2298 46) rotate(41.5724) scale(55.5942 55.5516)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#FF456A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF28A9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.cd686314ebccb2032de60d0afa57d55e.svg";
export { ForwardRef as ReactComponent };